export const USER_ROLES = {
    ADMIN: 'admin',
    USER: 'user',
    AGENCY: 'agency',
    ACCOUNT: 'account',
};
export const IMAGE_GENERATION_DEFAULTS = {
    DESCRIPTION: '',
    NUMBER_OF_VARIATIONS: 1,
    PRESET: undefined,
};
export const MEDIA_LIBRARY_FOLDER_NAME = 'Content AI';
export const PENDO_MODULE_EVENT_NAME = {
    social_planner: 'Social Planner',
    blog: 'Blog',
    funnel: 'Funnels',
    website: 'Website',
    email_builder: 'Email Builder',
};
export const DEFAULT_FIELD_MAPPING_KEY = 'default';
